import { ChevronRightIcon } from '@/components/icons/ChevronRightIcon';
import { getL2LightImageUrl } from '@/utils/nutrition/getImageUrl';
import { EventTracker } from '@/utils';
import { cn } from '@/utils/styles';
import { useNavigate } from 'react-router-dom';

interface NutritionCardProps {
  boosterBlockerId: number;
  title: string;
  images: string[];
  foodCount: number;
  icon_url: string;
}

export const NutritionEssentialCard = ({
  boosterBlockerId,
  title,
  images,
  foodCount,
  icon_url,
}: NutritionCardProps) => {
  const navigate = useNavigate();
  const handleNavigation = (id: number) => {
    EventTracker.trackEvent('home', `home_nutritionSummary_improve_${title}`);
    navigate(`/boosters-and-blockers/${id}`);
  };

  return (
    <div
      className={cn(
        'w-80 cursor-pointer',
        'p-5 rounded-2xl',
        'bg-white/70 backdrop-blur-[50px]',
        'shadow-[0px_1px_0px_0px_rgba(255,255,255,0.04)_inset,0px_1px_3px_0px_rgba(0,0,0,0.1)]',
      )}
      onClick={() => handleNavigation(boosterBlockerId)}
    >
      <div className="flex">
        {icon_url && (
          <img
            src={getL2LightImageUrl(icon_url)}
            alt={title}
            className="w-12 h-12"
          />
        )}
        <h3 className="typography-h3 text-primary ml-2 mt-3 mb-8">{title}</h3>
      </div>

      <div className="flex items-center justify-between">
        <div className="flex">
          {images.map((image, index) => (
            <div
              key={index}
              className={cn('relative', index !== 0 && '-ml-[22px]')}
              style={{
                zIndex: images.length + index,
              }}
            >
              <div className="w-12 h-12 rounded-full border border-stroke-secondary-subtle backdrop-blur-[17.45px] overflow-hidden">
                <img
                  src={image}
                  alt={`Food item ${index - 1}`}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          ))}
        </div>

        <div className="flex items-center text-primary">
          <span className="typography-caption2">
            {foodCount} foods & ingredients
          </span>
          <ChevronRightIcon className="w-5 h-5" />
        </div>
      </div>
    </div>
  );
};
